import { mutateGraphQL } from '~/hooks/graphql.js';

const sendResetPasswordEmail = `
  mutation SendResetPasswordEmail($username: String!) {
		sendPasswordResetEmail(input: { username: $username }) {
			success
		}
	}
`;

const resetUserPassword = `
	mutation ResetUserPassword($key: String!, $login: String!, $password: String!) {
    resetUserPassword(input: { key: $key, login: $login, password: $password }) {
      user {
        userId
      }
    }
}
`;

/**
 * mutateGraphQL returns a callback method.
 */
export const getResetPasswordRequestMutationHandler = () => {

  const { mutationHandler } = mutateGraphQL(sendResetPasswordEmail);

  return { mutationHandler };
}

export const getResetPasswordMutationHandler = () => {

  const { mutationHandler } = mutateGraphQL(resetUserPassword);

  return { mutationHandler };
}
